/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Card from "../Card";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Chart5 = ({ title, datas, d2, di, color }) => {
  const labels = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
  const darr = labels.map((l) => {
    const key = d2 + l;
    return datas[key]?.[di] ?? 0;
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false },
      datalabels: {
        display: false,
      },
      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: color,
        borderColor: color,
        borderWidth: 1,
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return value != null ? ` ${value}` : null;
          },
          title: function (context) {
            return context[0].label || "";
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#555",
          autoSkip: false,
          maxRotation: 45,
          minRotation: 0,
        },
        grid: { display: false },
      },
      y: {
        ticks: {
          color: "#777",
          beginAtZero: true,
        },
        grid: {
          color: "#eee",
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "Ko'rsatgich: ",
        data: darr,
        borderColor: color,
        backgroundColor: `${color}33`,
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  return (
    <Card>
      <div className='chart-box-all bg-chart8 p-4 h-[300px]'>
        <h4 className='title chart-title mb-3'>{title}</h4>
        <Line options={options} data={data} />
      </div>
    </Card>
  );
};

export default Chart5;
